import { createTooltipDescriptionRow, createTooltipRightDescriptionRow, createDivider } from "./tooltip_components.js"
import { seconds_to_minutes_seconds, imgPath } from "./math_functions.js"
import { commander } from "./singletons.js"

var elements_colors_semi_transparent = {
    'solar': '#904c0fcc',
    'void': '#5f247fcc',
    'arc': '#47bfdbcc',
    'stasis': '#203893cc',
    'strand': '#1a9543cc',
    'prismatic': '#ff40d0cc',
    'any': '#323232cc'
};

var rarity_semi_transparent = {
    "exotic": "#cca81ecc",
    "legendary": "##a903fccc"
}

export function update_tooltip(character, effect_id, displayMode, button_level)
{
    let effect = character.get_effect(effect_id);
    console.log(effect_id, effect)

    // TOOLTIP HEAD
    // head background color
    if ('element' in effect) // if has element coloring according to element
    {
        if (effect.element == 'any')
            document.getElementById("tooltip_head").style.backgroundColor = elements_colors_semi_transparent[character.element];
        else
            document.getElementById("tooltip_head").style.backgroundColor = elements_colors_semi_transparent[effect.element];
    }
    else if ("rarity" in effect) // if no element but have rarity coloring according ot rarity
    {
        if (effect.rarity == "exotic") // currently only for exotics
            document.getElementById("tooltip_head").style.backgroundColor = rarity_semi_transparent[effect.rarity];
        else // TODO: add another rarity colors
            document.getElementById("tooltip_head").style.backgroundColor = '#323232cc';
    }
    else // if no rarity and element - gray
        document.getElementById("tooltip_head").style.backgroundColor = '#323232cc';

    // name
    document.getElementById("tooltip_name").textContent = effect.display_properties.name;

    // display type
    document.getElementById("tooltip_effect_type").textContent = effect.display_properties.display_type;

    // right corner element icon
    let img = document.getElementById('tooltip_head_corner');

    if (character.element == 'prismatic' && effect.element != 'prismatic' && effect.element != 'any' &&
        (effect.type == 'super_ability' || effect.type == 'melee_ability' || effect.type == 'grenade_ability' || effect.type == 'class_ability' || effect.type == 'aspect'))
    {
        img.style.visibility = 'visible';
        img.src = imgPath(`right_corner_${effect.element}.png`);
    }
    else
        img.style.visibility = 'hidden';

    // TOOLTIP SECONDARY ICON
    if ("secondary_icon" in effect.display_properties && displayMode == "pc")
    {
        document.getElementById("tooltip_secondary_icon").style.display = 'block';
        document.getElementById("tooltip_secondary_icon").src = imgPath(`${effect.display_properties.secondary_icon}`);
    }
    else
        document.getElementById("tooltip_secondary_icon").style.display = 'none';

    // currently applied block
    if ( button_level == 2 && effect.counter > 0 &&
        ((effect.type == 'aspect' && effect.id != 'empty_aspect_socket_aspect') || (effect.type == 'fragment' && effect.id != 'empty_fragment_socket_fragment')))
    {
        document.getElementById('tooltip_currently_applied').style.display = 'block';
    }
    else
        document.getElementById('tooltip_currently_applied').style.display = 'none';

    // socket capacity display
    console.log("aspect check", effect)
    if (effect.type == 'aspect' && effect_id != 'empty_aspect_socket_aspect')
    {
        document.getElementById('tooltip_fragment_slots_counter').innerText = `${effect.fragment_capacity}`;
        document.getElementById('tooltip_fragment_slots').style.display = 'block';

        for (let i = 0; i < effect.fragment_capacity; i++)
            document.getElementById(`small_fragment_icon_${i}`).classList.remove('small_fragment_slot_icon_inactive');

        for (let i = effect.fragment_capacity; i < 3; i++)
            document.getElementById(`small_fragment_icon_${i}`).classList.add('small_fragment_slot_icon_inactive');
    }
    else
        document.getElementById('tooltip_fragment_slots').style.display = 'none';

    // flavor text
    if (effect.type == "aspect" && effect.id != "empty_aspect_socket_aspect")
    {
        let lore = document.getElementById("flavor_text");
        lore.style.display = 'block';
        lore.textContent = effect.flavor_text;
    }
    else
        document.getElementById("flavor_text").style.display = 'none';

    // description
    form_tooltip_description(effect);
}


export function form_tooltip_description(effect)
{
    let res = []

    if ("description" in effect.display_properties)
        res.push(createTooltipDescriptionRow("", effect.display_properties.description))

    if ("perks" in effect && effect.perks != null)
    {
        for (let perk_description of effect.perks)
        {
            if (perk_description.condition != null)
            {
                let request_result = commander.sendRequest(
                    {
                        request_type: "check_condition",
                        condition: perk_description.condition
                    }
                );

                if (request_result)
                {
                    let perk_obj = character.get_effect(perk_description.id);
                    console.log("obj", perk_description.id, perk_obj);

                    res.push(createTooltipDescriptionRow(perk_obj.display_properties.icon, perk_obj.display_properties.description))
                }
            }
            else
            {
                let perk_obj = character.get_effect(perk_description.id);
                console.log("obj", perk_description.id, perk_obj);

                res.push(createTooltipDescriptionRow(perk_obj.display_properties.icon, perk_obj.display_properties.description))
            }
        }
    }

    if (effect.type == 'grenade_ability' || effect.type == 'class_ability' || effect.type == 'melee_ability' || effect.type == 'super_ability')
        res.push(createTooltipDescriptionRow('', `Base Cooldown: <b>${seconds_to_minutes_seconds(effect.get_cooldown())}`));

    document.getElementById("tooltip_description").replaceChildren(...res);
}

export function update_tooltip_right(character, effect_id)
{
    let effect = character.get_effect(effect_id);

    if (effect.trait_ids != null)
    {
        let res = [];
        let len = effect.trait_ids.length
        for (let i = 0; i < len - 1; i++)
        {
            res.push(
                createTooltipRightDescriptionRow(
                    character.traits[effect.trait_ids[i]].icon,
                    character.traits[effect.trait_ids[i]].name,
                    character.traits[effect.trait_ids[i]].description
                )
            );


            res.push(createDivider());
        }

        res.push(createTooltipRightDescriptionRow(character.traits[effect.trait_ids[len - 1]].icon, character.traits[effect.trait_ids[len - 1]].name, character.traits[effect.trait_ids[len - 1]].description));

        document.getElementById("tooltip_right").replaceChildren(...res);
        return true;
    }

    return false;
}
/*
_trait: {
        name: "",
        description: "",
        icon: "",
    },
*/


let side = "to_right";
let animation;

let animations_show = {
    "to_right": {
        keyframes: [
            { transform: 'translateX(0px)', opacity: 0 }, // начальные значения
            { transform: 'translateX(410px)', opacity: 1 } // конечные значения
        ],
        options: {
            duration: 1000, // Длительность анимации в миллисекундах
            easing: 'ease', // Плавность анимации
            fill: 'forwards' // Сохраняем конечное состояние после завершения анимации
        }
    },
    "to_left": {
        keyframes: [
            { transform: 'translateX(0px)', opacity: 0 }, // начальные значения
            { transform: 'translateX(-410px)', opacity: 1 } // конечные значения
        ],
        options: {
            duration: 1000, // Длительность анимации в миллисекундах
            easing: 'ease', // Плавность анимации
            fill: 'forwards' // Сохраняем конечное состояние после завершения анимации
        }
    }
};

export function animateElement(element, side) {
    // Сначала показываем элемент
    element.style.visibility = 'visible';

    // Запуск анимации появления элемента
    animation = element.animate(animations_show[side].keyframes, animations_show[side].options);

}

export function hideElement(element)
{
    element.style.visibility = 'hidden';
}